// This is a temporary file
// It will be used from registration and my account profile update phone prefix list
// The list will eventually be stored in CMS
export const userPhonePrefixList = [
    {
        id: 1,
        countryCode: 'US',
        name: '+1',
        value: '+1',
    },
];
